import React from 'react';

import { clsx } from 'clsx';

import styles from './styles.module.css';

type Props = {
  children: React.ReactNode;
  displayBreakpoint?: 'xlUp' | 'lgUp' | 'lgDown' | 'mdUp' | 'smUp';
  handleNavigationListItemClick?: () => void;
  className?: string;
};

export function NavigationListItem({
  children,
  displayBreakpoint,
  handleNavigationListItemClick,
  className,
  ...rest
}: Props) {
  const conditionalListItemStyles = {
    [styles['navigationListItem--xlUp']]: displayBreakpoint === 'xlUp',
    [styles['navigationListItem--lgUp']]: displayBreakpoint === 'lgUp',
    [styles['navigationListItem--lgDown']]: displayBreakpoint === 'lgDown',
    [styles['navigationListItem--mdUp']]: displayBreakpoint === 'mdUp',
    [styles['navigationListItem--smUp']]: displayBreakpoint === 'smUp',
  };
  const conditionalProps = {
    ...(handleNavigationListItemClick && {
      onClick: handleNavigationListItemClick,
    }),
  };

  return (
    <li
      className={clsx(
        styles.navigationListItem,
        conditionalListItemStyles,
        className
      )}
      {...conditionalProps}
      {...rest}
    >
      {children}
    </li>
  );
}
